var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-pg"},[_c('div',{staticClass:"sign-row"},[_c('div',{staticClass:"confirm-email"},[(_vm.success)?[_c('p',[_vm._v(" "+_vm._s(_vm.$t("Регистрация успешно завершена!"))+" ")]),_c('p',[_c('router-link',{attrs:{"to":_vm.$i18nRoute({ name: 'profile' })}},[_vm._v(" "+_vm._s(_vm.$t("Личный кабинет"))+" ")])],1)]:_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }